const messages = {
  transactionRefund: {
    amount: "Amount is required",
    amountValid: "Enter a valid amount",
  },

};

export default messages;
